import { useReactiveVar } from '@apollo/client';
import { Divider, Stack } from '@ui-components/neo.tax';

import { useAuthRedirect, useSsoCustomTokenSignIn } from '@neo.tax/onboarding/hooks';
import { TestimonialMemo, StyledSplitScreen, AuthFormHeader, SsoButtonsSection } from '@neo.tax/onboarding/organisms';
import { AuthType, AuthenticationState, Loader } from '@neo.tax/shared';
import { useUserFromAuth } from '@neo.tax/shared/hooks/useUserFromAuth';

import { FinishSignup, SignupForm } from './organisms';

export const Signup = (): React.ReactElement => {
  useSsoCustomTokenSignIn();

  const { authenticationServiceState } = useReactiveVar(AuthenticationState.authenticationStateVar);
  const isAuthenticated = !!authenticationServiceState.authenticationUser;
  const { existsInDb, loading } = useUserFromAuth();
  // Authenticated in Firebase but not provisioned in our DB → finish provisioning, not a fresh signup.
  // (useAuthRedirect routes these sessions here; it also renders, rather than re-redirects, on /signup.)
  const isUnprovisioned = isAuthenticated && !loading && !existsInDb;

  return (
    <Loader useRedirect={useAuthRedirect}>
      <StyledSplitScreen
        leftSide={
          <AuthFormHeader
            pageChangeText="already have an account?"
            pageChangeLinkText="Login"
            pageChangeTo="/login"
            title={isUnprovisioned ? 'Finish setting up your account' : 'Create your free account'}
            form={
              isUnprovisioned ? (
                <FinishSignup />
              ) : (
                <Stack direction="column">
                  <SsoButtonsSection authType={AuthType.SIGNUP} />
                  <Divider>Or continue with</Divider>
                  <SignupForm />
                </Stack>
              )
            }
          />
        }
        rightSide={<TestimonialMemo />}
      />
    </Loader>
  );
};
